import { useContext } from 'react';

import { RenderedNavigationContext } from './context';

export function useDisabledRenderedNavigation(): boolean {
	return !!useContext(RenderedNavigationContext)?.disabledRenderedNavigation;
}
